import type { KeyboardEvent } from 'react';

/** Email shape the login and sign-up forms accept (`register().pattern.value`). */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// DS Typography has no cursor prop — required for interactive non-button text
export const LINK_STYLE = { cursor: 'pointer' } as const;

/** Runs `handler` on Enter or Space, so a `role="button"` Typography activates like a button. */
export const activateOnSpaceOrEnter = (handler: () => void) => (e: KeyboardEvent) => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    handler();
  }
};
